module.exports = __webpack_public_path__ + "static/robot_image1-aa7727145c0b981498887ff4bd26f249.png";